// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1yInu","list":"BalanceDue_list__dt_OO","listRow":"BalanceDue_listRow__7X9De","total":"BalanceDue_total__134q2"};